import { get } from 'lodash';
import helpers from './helpers';

export default {
  isLoggedIn: (state) => {
    const { token, login_at: loginAt, id } = get(state, 'user', true);
    return token && loginAt && id;
  },
  userData: state => get(state, 'user', true),
  currentCount: state => Number(get(state, 'count', 0)),
  formObject: state => get(state, 'formObject', {}),
  accessToken: state => get(state, 'token'),
  isLoadingPage: state => get(state, 'loadingPage', false),
  isLoadingRequest: state => get(state, 'loadingRequest', false),
  isModalShowing: state => get(state, 'modalShowing', false),
  isAdmin: state => get(state, 'isAdmin', false),
  isRoot: state => get(state, 'isRoot', false),
  isApprover: state => get(state, 'isApprover', false),
  isApproverNoRequest: state => get(state, 'isApproverNoRequest', false),
  firstLogin: () => helpers.getFromLocal('firstLogin'),
  initPassword: state => get(state, 'initPassword', false),
  isTimesheetSubmitEnabled: (state) => {
    const settings = get(state, 'settings', null);
    if (Array.isArray(settings)) {
      const settingToFind = settings.find(s => s.name === 'enable_timesheet_submit');
      return get(settingToFind, 'value', false);
    }
    return false;
  },
};
